import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Grid } from '@mui/material';
import PrimaryButton from './Button/PrimaryButton';

interface ConfirmationModalProps {
  open: boolean;
  title?: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  title = 'Confirm Delete',
  message,
  onConfirm,
  onCancel,
  confirmText = 'Yes',
  cancelText = 'No',
}) => (
  <Dialog open={open} onClose={onCancel} fullWidth maxWidth={'xs'} sx={{ p: 3 }}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>{message}</DialogContent>
    <DialogActions sx={{ pb: 2 }}>
      <Grid item xs={6}>
        <PrimaryButton variant="outlined" onClick={onCancel}>
          {cancelText}
        </PrimaryButton>
      </Grid>
      <Grid item xs={6}>
        <PrimaryButton onClick={onConfirm}>{confirmText}</PrimaryButton>
      </Grid>
    </DialogActions>
  </Dialog>
);

export default ConfirmationModal;
